import React from "react";
import { Trans } from "react-i18next";
import { Spinner, Callout, H2, H5 } from "@blueprintjs/core";
import i18next from "i18next";
import i18n from "../../../i18n";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import KeyData from "../../Structure/KeyData";


export default class FinancialSummary extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      labels: [],
      loading: true
    };
  }

  ac = new AbortController();

  componentDidMount() {
    this.setState({ loading: true });
    if (this.props.urlsearchparams) {
      authenticatedGetFetch('/financial/summary?' + this.props.urlsearchparams,
        (res) => {
          this.setState({
            loading: false,
            sum: res['sum'],
            nb: res['nb'],
            avg: res['avg']
          });
        }, null, this.ac.signal);
    }
  }

  componentWillUnmount() {
    this.ac.abort();
  }

  render() {
    return (this.props.urlsearchparams) ?
      (this.state.loading) ?
        <Spinner />
        : (this.state.nb > 0) ? <Callout intent="primary">
          <div>
            <div><H2 className="space-title"><Trans>financial report</Trans></H2>
              <H5 className="space-title"><Trans>from</Trans> {new Date(this.props.dateRange[0]).toLocaleDateString(i18next.language)} <Trans>to</Trans> {new Date(this.props.dateRange[1]).toLocaleDateString(i18next.language)}</H5>
            </div>
            <div className="flexbox-left">
              <KeyData label={i18n.t("registered payments")} data={parseInt(this.state.nb)} />
              <KeyData label={i18n.t("for a total of")} data={parseFloat(this.state.sum / 100)} float={2} unit='€' />
              <KeyData label={i18n.t("an average payment of")} data={parseFloat(this.state.avg) / 100} float={2} unit='€' />
            </div>
          </div></Callout >
          : <Callout intent="warning"><Trans>no payment registered during the selected period</Trans></Callout>
      : null
  }
}